import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = {
    path: '',
    component: () =>
        import('../../../layouts/main/Main.vue'),
    children: [
        {
            path: '/clinic-and-professionals',
            name: 'clinic-and-professionals',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./ClinicAndProfessionals/ClinicAndProfessionals.vue')
        },
        {
            path: '/clinics-registered',
            name: 'clinics-registered',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./ClinicsRegistered/ClinicsRegistered.vue')
        },
        {
            path: '/clinics-registered-report',
            name: 'clinics-registered-report',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./ClinicsRegisteredReport/ClinicsRegisteredReport.vue')
        },
        {
            path: '/pages-clinic/:id/:name',
            name: 'pages-clinic',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./AdminVisionClinics/AdminVisionClinics.vue')
        },
        {
            path: '/quicksight-clinic-dashboard',
            name: 'quicksight-clinic-dashboard',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./QuicksightClinic/QuicksightClinic.vue')
        },
    ]
}
export default [
    routes
]

